import type { OwnTransportIngredient } from '@apps/main/modules/recipe/ingredients';

import type { OwnTransportIngredientAdapter } from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';

export function adaptOwnTransportIngredientToItinerarySearchCriteria(
  ingredient: OwnTransportIngredient
): OwnTransportIngredientAdapter {
  return {
    ingredientType: IngredientType.OwnTransport,
    ingredientId: ingredient.ingredientId,
    ownTransportType: ingredient.ownTransportType,
  };
}
